import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import Formatted from '@flipster/react/design-utils/formatted';
import { IsomorphicLink } from '@flipster/react/design-utils/isomorphic-link';
import ArrowRightIcon from '@flipster/react/icon/generated/ArrowRightIcon';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import TagIcon from '@flipster/react/icon/generated/TagIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { maxDecimalPrecision } from '@flipster/utils/constants/currency';

import { spotFormBunja } from './bunja/form';
import { spotTradingFeeBunja } from './bunja/trading-fee';

const TradingFee = () => {
  const { priceTypeAtom } = useBunja(spotFormBunja);
  const { estimatedTradingFeeRatePercentAtom, feeDiscountStateAtom, isFullDiscountAtom } =
    useBunja(spotTradingFeeBunja);

  const priceType = useAtomValue(priceTypeAtom);
  const estimatedTradingFeeRatePercent = useAtomValue(estimatedTradingFeeRatePercentAtom);
  const feeDiscountState = useAtomValue(feeDiscountStateAtom);
  const isFullDiscount = useAtomValue(isFullDiscountAtom);

  const showFeeDetails = priceType === 'market' || priceType === 'trigger';

  return (
    <div className={css({ py: 16 })}>
      <IsomorphicLink
        href='/support/guide/fees'
        newTab
        className={hstack({ mb: 4, textStyle: 'Text/M/Strong', color: 'content.default.level-2', gap: 4 })}
      >
        <FormattedMessage id='Trade.r250709.Trading_fee' />
        <ChevronRightIcon size={16} />
      </IsomorphicLink>
      {showFeeDetails && (
        <>
          <div className={hstack({ gap: 4, textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>
            <Formatted.Percent
              value={estimatedTradingFeeRatePercent}
              precision={maxDecimalPrecision}
              css={{ textDecoration: isFullDiscount ? 'line-through' : undefined }}
            />
            {isFullDiscount && (
              <>
                <ArrowRightIcon size={14} color={token('colors.content.default.level-2')} />
                <Formatted.Percent value='0' precision={maxDecimalPrecision} />
              </>
            )}
          </div>
          {feeDiscountState?.message != null && (
            <div className={hstack({ gap: 4 })}>
              <TagIcon size={16} color={token('colors.content.default.level-3')} />
              <p className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-2' })}>
                {feeDiscountState.message}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TradingFee;
